import { css, type Theme } from "@emotion/react";

export const BrandLogosBox = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
`;

export const FeaturedBrand = (theme: Theme) => css`
  width: 100%;
  height: 100%;
  border: 1px solid ${theme.system.borderBase};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`;

export const FeaturedBrandsSpacing = css`
  display: flex;
  justify-content: center;
`;

export const FeaturedBrandsImage = css`
  object-fit: contain;
  max-height: 4.56rem;
  margin: 0 auto;
`;
